const sortOrder = [
  {
    name: 'Last Name',
    value: 1
  },
  {
    name: 'Date',
    value: 2
  },
  {
    name: 'Resource Collection',
    value: 3
  },
];

export default sortOrder;


// WEBPACK FOOTER //
// ./src/Components/Approval/utils/sortOrder.js